export const GET_USERS = 'GET_USERS'
export const GET_USER = 'GET_USER'
export const GET_COUNTRIES = 'GET_COUNTRIES'
export const GET_STATES = 'GET_STATES'
export const SEARCH_USERS = 'SEARCH_USERS'

export const SEARCH_PARTICIPANTS = 'SEARCH_PARTICIPANTS'
export const SET_PARTICIPANTS = 'SET_PARTICIPANTS'
export const GET_PARTICIPANTS = 'GET_PARTICIPANTS'
export const GET_PARTICIPANT = 'GET_PARTICIPANT'

export const GET_RESOURCES_GROUPS = 'GET_RESOURCES_GROUPS'
export const GET_RESOURCE_GROUP_TYPES = 'GET_RESOURCE_GROUP_TYPES'
export const GET_RESOURCE_TYPE_GROUPS = 'GET_RESOURCE_TYPE_GROUPS'
export const GET_EVENT_RESOURCES_GROUPS = 'GET_EVENT_RESOURCES_GROUPS'

export const GET_SERVICE_POINTS = 'GET_SERVICE_POINTS'
export const GET_OCCUPATIONS = 'GET_OCCUPATIONS'

export const GET_CATEGORY_TYPES = 'GET_CATEGORY_TYPES'
export const GET_POSSIBLE_CATEGORY_TYPES = 'GET_POSSIBLE_CATEGORY_TYPES'
export const GET_ACCOMODATION_POSSIBLE_CATEGORY_TYPES = 'GET_ACCOMODATION_POSSIBLE_CATEGORY_TYPES'
export const GET_POSSIBLE_CATEGORY_VALUES = 'GET_POSSIBLE_CATEGORY_VALUES'

export const GET_ACCOMODATIONS = 'GET_ACCOMODATIONS'
export const GET_ACCOMODATION = 'GET_ACCOMODATION'
export const SET_REGULAR_ACCOMODATION = 'SET_REGULAR_ACCOMODATION'
export const SET_SPECIAL_ACCOMODATION = 'SET_SPECIAL_ACCOMODATION'
export const SET_ACCOMODATION_ID = 'SET_ACCOMODATION_ID'

export const GET_ROOMS = 'GET_ROOMS'
export const GET_ROOMS_BY_ID = 'GET_ROOMS_BY_ID'
export const GET_ROOM = 'GET_ROOM'
export const GET_ROOM_TYPE_VALUES = 'GET_ROOM_TYPE_VALUES'

export const GET_FEEDBACKS = 'GET_FEEDBACKS'

export const CHECKEDIN = 'CHECKEDIN'
export const GET_EVENTS = 'GET_EVENTS'
export const GET_EVENT = 'GET_EVENT'
export const GET_EVENT_STATS = 'GET_EVENT_STATS'
export const SEARCH_EVENTS = 'SEARCH_EVENTS'
export const SELECTED_EVENT = 'SELECTED_EVENT'

export const GET_SESSIONS = 'GET_SESSIONS'
export const GET_STATS = 'GET_STATS'
export const GET_USER_SESSIONS = 'GET_USER_SESSIONS'
export const SET_SESSION_EVENT = 'SET_SESSION_EVENT'
export const GET_SESSION_EVENT = 'GET_SESSION_EVENT'
export const SET_SESSION_EVENT_TITLE = 'SET_SESSION_EVENT_TITLE'
export const SHOW_SELECT = 'SHOW_SELECT'
export const SET_SESSION_ID = 'SET_SESSION_ID'

export const SET_SIDEBAR = 'SET_SIDEBAR'
export const SET_USER_EMAILS = 'SET_USER_EMAILS'

export const GET_CENTERS = 'GET_CENTERS'
export const GET_CENTER_REPORTS = 'GET_CENTER_REPORTS'
export const GET_CENTER_REPORT = 'GET_CENTER_REPORT'
export const SEARCH = 'SEARCH'
export const FILTER = 'FILTER'

export const SET_PAGINATION = 'SET_PAGINATION'
export const SET_EVENT_PAGINATION = 'SET_EVENT_PAGINATION'
export const SET_ACCOMODATION_PAGINATION = 'SET_ACCOMODATION_PAGINATION'
export const SET_ROOMS_PAGINATION = 'SET_ROOMS_PAGINATION'
export const SET_PARTICIPANT_PAGINATION = 'SET_PARTICIPANT_PAGINATION'
export const SET_SEARCH_PARTICIPANT_PAGINATION = 'SET_SEARCH_PARTICIPANT_PAGINATION'
export const SET_SEARCH_PAGINATION = 'SET_SEARCH_PAGINATION'
export const SET_RESOURCE_GROUP_TYPE_PAGINATION = 'SET_RESOURCE_GROUP_PAGINATION'
export const SET_RESOURCE_TYPE_GROUPS_PAGINATION = 'SET_RESOURCE_TYPE_GROUPS_PAGINATION'
export const SET_RESOURCE_GROUP_PAGINATION = 'SET_RESOURCE_GROUP_PAGINATION'
export const GET_CENTER_REPORTS_PAGINATION = 'GET_CENTER_REPORTS_PAGINATION'
export const SET_RESOURCE_GROUPS_VALUES = 'SET_RESOURCE_GROUPS_VALUES'
export const SET_INCOME_ITEMS = 'SET_INCOME_ITEMS'
export const SET_REPORTEE_ITEMS = 'SET_REPORTEE_ITEMS'
export const SET_CENTER_PASTOR_ITEMS = 'SET_CENTER_PASTOR_ITEMS'
export const SET_NON_COMITTED_DISCIPLES_ITEMS = 'SET_NON_COMITTED_DISCIPLES_ITEMS'
export const SET_REGULAR_MEETING_ITEMS = 'SET_REGULAR_MEETING_ITEMS'
export const SET_SPECIAL_MEETING_ITEMS = 'SET_SPECIAL_MEETING_ITEMS'
export const SET_CENTER_EXTENSION_ITEMS = 'SET_CENTER_EXTENSION_ITEMS'
export const SET_EXPENDITURE_ITEMS = 'SET_EXPENDITURE_ITEMS'
export const SET_YEAR_ON_YEAR_ITEMS = 'SET_YEAR_ON_YEAR_ITEMS'


export const SET_LOADING = 'SET_LOADING'

export const GET_ATTENDANCE_HISTORY = 'GET_ATTENDANCE_HISTORY'
export const SET_ATTENDANCE_HISTORY_PAGINATION = 'SET_ATTENDANCE_HISTORY_PAGINATION'
export const CLEAR_ATTENDANCE_HISTORY = 'CLEAR_ATTENDANCE_HISTORY'

export const GET_FOLLOW_UPS = 'GET_FOLLOW_UPS'
export const GET_FOLLOW_UP = 'GET_FOLLOW_UP'
export const SET_FOLLOW_UP_PAGINATION = 'SET_FOLLOW_UP_PAGINATION'
export const CLEAR_FOLLOW_UPS = 'CLEAR_FOLLOW_UPS'